import React, { useState } from 'react'
import { StyledLink } from '../../components/StyledComponents';
import { useTranslation } from 'react-i18next';

const BlogCard = (props) => {
    const { t } = useTranslation()

    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    const highlightText = (text) => {
        const query = props.searchQuery.toLowerCase();
        const index = text.toLowerCase().indexOf(query);
        if (index === -1) {
            return text;
        }
        const firstPart = text.substring(0, index);
        const highlightedPart = text.substring(index, index + query.length);
        const lastPart = text.substring(index + query.length);
        return (
            <span>
                {firstPart}
                <span style={{ backgroundColor: '#FF3C00' }}>{highlightedPart}</span>
                {lastPart}
            </span>
        );
    };



    return (
        <div className={`blog-card ${isExpanded ? "active" : ""}`}>
            <StyledLink href={`/blog${props.item.url}`}>
                <div className='blog-card_image'>
                    <img src={props.item.image} alt="" className='img-responsive' />
                </div>
            </StyledLink>
            <div className='blog-list-chip pt-20'>
                {props.item.tags.map((tag, index) => (
                    <div className='case-study-chip' key={index}>
                        {tag}
                    </div>
                ))}
            </div>
            <StyledLink>
                <p className='pt-20 text-white font-20 font-weight-semi-bold'>
                    {/* {item.title} */}
                    {highlightText(props.item.title)}
                </p>
            </StyledLink>
            <p className='text-gray pt-10'>{props.item.date_time}</p>
            {
                props.item.content.length < 150
                    ?
                    <p className='text-gray pt-10 max-line-2'>
                        {props.item.content}
                    </p>
                    :
                    <p className='text-gray pt-10 max-line-2'>
                        {
                            !isExpanded ? highlightText(props.item.content.slice(0, 150)) : highlightText(props.item.content)
                        }
                        <span onClick={toggleExpanded} className='read-more-btn'>...{!isExpanded ? t('button.read-more') : t("button.read-less")}</span>
                    </p>
            }
        </div >
    )
}

export default BlogCard